/**
 * Analytics Portal V1 — Capital Analytics (Phase 13, plan §4.5 + §14 + §15 + §11 endpoint 6).
 * A pure renderer of `GET /api/analytics/capital` through the shared entity dashboard, plus the two
 * Capital-only sections: directory discovery and pitch-deck interest.
 */
import React from "react";
import { CapitalDirectoryCard } from "@/components/analytics/CapitalDirectoryCard";
import { EntityDashboard } from "@/components/analytics/EntityDashboard";
import { NamedVisitorPanel } from "@/components/analytics/NamedVisitorPanel";
import { PitchDeckSection } from "@/components/analytics/PitchDeckSection";
import { CAPITAL_GROUPS, CAPITAL_HEADLINE } from "@/components/analytics/capitalMetrics";
import { useAnalyticsPortal } from "./AnalyticsPortal";

export default function CapitalTab() {
  const portal = useAnalyticsPortal();
  const payload = portal?.payload;

  return (
    <EntityDashboard
      portal={portal}
      testId="analytics-view-capital"
      scopeType="capital"
      headline={CAPITAL_HEADLINE}
      groups={CAPITAL_GROUPS}
      funnelTitle="Capital conversion funnel"
      noActivityBody="This Capital profile's analytics will populate once eligible activity is collected."
      beforeGroups={payload && (
        <CapitalDirectoryCard directory={payload.directory}
                              rangeSuggestion={payload.range_suggestion}
                              onUseSupportedRange={portal.onUseSupportedRange} />
      )}
      afterGroups={payload && (
        <>
          <PitchDeckSection pitchDecks={payload.pitch_decks}
                            rangeSuggestion={payload.range_suggestion}
                            onUseSupportedRange={portal.onUseSupportedRange}
                            onChangeRange={portal.onChangeRange} />
          <NamedVisitorPanel entityType="capital" entityId={portal.entity}
                             capabilities={payload.capabilities} range={portal.range} />
        </>
      )}
    />
  );
}
